// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__1dAm-","label":"Checkbox_label__27iBu","input":"Checkbox_input__16t4m"};